import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useRef } from 'react';
import { FC, memo } from 'react';
import { BluDialogInterface } from './interface';
import '../../styles/print.css';

const BluDialog: FC<BluDialogInterface> = memo(
  ({
    open,
    zIndex,
    dialogTitle,
    dialogTitleProps,
    dialogContent,
    dialogContentProps,
    dialogActions,
    dialogActionsProps,
    draggable,
    ...rest
  }) => {
    const componentRef = useRef();

    return (
      <Dialog open={open} fullWidth maxWidth="xl" {...rest}>
        {dialogTitle && (
          <DialogTitle {...dialogTitleProps}>{dialogTitle}</DialogTitle>
        )}
        <DialogContent ref={componentRef} {...dialogContentProps}>
          {dialogContent}
        </DialogContent>
        <DialogActions {...dialogActionsProps}>{dialogActions}</DialogActions>
      </Dialog>
    );
  },
);

export default BluDialog;
